import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '../config/apiconfig';

function Section({ title, children }) {
  return (
    <section className="bg-white rounded-xl shadow p-6 mb-8">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      {children}
    </section>
  );
}

export default function AdminDepartmentsDesignations() {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [assigned, setAssigned] = useState([]);
  const [newDept, setNewDept] = useState('');
  const [newDesg, setNewDesg] = useState('');

  const authHeaders = useMemo(() => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
  }, []);

  async function loadDepartments() {
    const r = await fetch(`${API_BASE_URL}/admin/departments`, { headers: authHeaders });
    if (r.ok) setDepartments(await r.json());
  }
  async function loadDesignations() {
    const r = await fetch(`${API_BASE_URL}/admin/designations`, { headers: authHeaders });
    if (r.ok) setDesignations(await r.json());
  }
  async function loadAssigned(deptId) {
    const r = await fetch(`${API_BASE_URL}/admin/department-designations/${deptId}`, { headers: authHeaders });
    if (r.ok) setAssigned(await r.json());
  }

  useEffect(() => { loadDepartments(); loadDesignations(); }, []);
  useEffect(() => { if (selectedDepartment) loadAssigned(selectedDepartment.id); }, [selectedDepartment]);

  async function addDept() {
    if (!newDept.trim()) return;
    const r = await fetch(`${API_BASE_URL}/admin/departments`, { method:'POST', headers: authHeaders, body: JSON.stringify({ name: newDept }) });
    if (r.ok) { setNewDept(''); loadDepartments(); }
  }
  async function addDesg() {
    if (!newDesg.trim()) return;
    const r = await fetch(`${API_BASE_URL}/admin/designations`, { method:'POST', headers: authHeaders, body: JSON.stringify({ name: newDesg }) });
    if (r.ok) { setNewDesg(''); loadDesignations(); if (selectedDepartment) loadAssigned(selectedDepartment.id); }
  }
  async function assign(desgId) {
    if (!selectedDepartment) return;
    await fetch(`${API_BASE_URL}/admin/department-designations/assign`, { method:'POST', headers: authHeaders, body: JSON.stringify({ department_id: selectedDepartment.id, designation_id: desgId }) });
    loadAssigned(selectedDepartment.id);
  }
  async function unassign(desgId) {
    if (!selectedDepartment) return;
    await fetch(`${API_BASE_URL}/admin/department-designations/unassign`, { method:'POST', headers: authHeaders, body: JSON.stringify({ department_id: selectedDepartment.id, designation_id: desgId }) });
    loadAssigned(selectedDepartment.id);
  }

  const assignedIds = new Set(assigned.map(a=>a.designation_id));

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <Section title="Departments">
        <div className="flex gap-2 mb-3">
          <input className="border rounded p-2 flex-1" placeholder="New department name" value={newDept} onChange={e=>setNewDept(e.target.value)} />
          <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={addDept}>Add</button>
        </div>
        <ul className="divide-y">
          {departments.map(d => (
            <li key={d.id} className={`p-2 cursor-pointer rounded ${selectedDepartment?.id===d.id?'bg-indigo-50':''}`} onClick={()=>setSelectedDepartment(d)}>
              {d.name} <span className="text-xs text-gray-500">({d.department_code})</span>
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Designations">
        <div className="flex gap-2 mb-3">
          <input className="border rounded p-2 flex-1" placeholder="New designation name" value={newDesg} onChange={e=>setNewDesg(e.target.value)} />
          <button className="px-3 py-2 bg-indigo-600 text-white rounded" onClick={addDesg}>Add</button>
        </div>
        <ul className="divide-y">
          {designations.map(g => (
            <li key={g.id} className="p-2 flex items-center justify-between">
              <span>{g.name} <span className="text-xs text-gray-500">({g.designation_code})</span></span>
              {selectedDepartment && (
                assignedIds.has(g.id) ? (
                  <button className="px-2 py-1 text-sm bg-red-100 text-red-700 rounded" onClick={()=>unassign(g.id)}>Unassign</button>
                ) : (
                  <button className="px-2 py-1 text-sm bg-green-100 text-green-700 rounded" onClick={()=>assign(g.id)}>Assign</button>
                )
              )}
            </li>
          ))}
        </ul>
      </Section>

      <Section title="Assigned Designations">
        {!selectedDepartment ? (
          <div className="text-gray-500">Select a department to view assignments.</div>
        ) : (
          <div>
            <div className="mb-2 font-medium">{selectedDepartment.name}</div>
            <ul className="list-disc pl-5">
              {assigned.map(a => (
                <li key={a.designation_id}>{a.name}</li>
              ))}
              {assigned.length===0 && <li className="text-gray-500">No designations assigned.</li>}
            </ul>
          </div>
        )}
      </Section>
    </div>
  );
}
